import { graphql } from "react-relay"

export const FileUploadRequestFragment = graphql`
  fragment FileUploadRequestFragment on FileUploadRequest {
    id
    createdAt
    createdBy
    type
    status
    sessionCode
  }
`
